import apiClient from './api';
import { User, UserRole, UserStatus } from '../types/user'; // تأكد من أن هذا المسار صحيح
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// (1) نوع بيانات لإنشاء مستخدم جديد
export interface NewUserData {
  phone: string;
  email: string;
  password: string;
  role: UserRole;
 status: UserStatus;
}

// نوع بيانات التحديث (موجود بالفعل)
export interface UpdateUserData {
  role?: UserRole;
  status?: UserStatus;
}



export interface NewUserData {
  name: string; // تأكد من أن الخادم يقبل هذا الحقل
  phone: string;
  email: string;
  password: string;
  role: UserRole;
  status: UserStatus;
}

// (2) نوع بيانات لتحديث مستخدم
export interface UpdateUserData {
  name?: string;
  phone?: string;
  role?: UserRole;
  status?: UserStatus;
}

// (3) !! النوع الجديد هنا !!
// نوع البيانات المختصرة للمستخدمين في القوائم المنسدلة
export interface UserSelectionData {
  id: number;
  email: string;
  role: UserRole;
  displayText: string;
}

/**
 * (4) !! الدالة الجديدة هنا !!
 * جلب قائمة مختصرة بالمستخدمين لاستخدامها في القوائم المنسدلة
 */
export const getUsersForSelection = async (): Promise<UserSelectionData[]> => {
  const response = await apiClient.get<{ data: UserSelectionData[] }>('/users/for-selection');
  return response.data.data;
};

/**
 * إنشاء مستخدم جديد (بواسطة المشرف)
 */

/**
 * (2) إنشاء مستخدم جديد (بواسطة المشرف)
 */
export const createUser = async (userData: NewUserData): Promise<User> => {
  // تأكد من أن لديك نقطة نهاية POST على /users في الخادم
  const response = await apiClient.post<{ data: User }>('/users', userData);
  return response.data.data;
};
// ... (قد يكون لديك دوال أخرى هنا)
export const getPagedUsers = async (params: TableParams): Promise<PagedResult<User>> => {
  const response = await apiClient.get<{ data: PagedResult<User> }>('/users/paged', { params });
  return response.data.data;
};

/**
 * جلب مستخدم بواسطة ID
 */
export const getUserById = async (id: number): Promise<User> => {
  const response = await apiClient.get<{ data: User }>(`/users/${id}`);
  return response.data.data;
};

/**
 * تحديث مستخدم موجود
 */
export const updateUser = async (id: number, userData: UpdateUserData): Promise<User> => {
  const response = await apiClient.put<{ data: User }>(`/users/${id}`, userData);
  return response.data.data;
};

/**
 * حذف مستخدم بواسطة ID
 */
export const deleteUser = async (id: number): Promise<void> => {
  await apiClient.delete(`/users/${id}`);
};
/**
 * دالة لجلب جميع المستخدمين الذين ينتظرون الموافقة
 * @returns مصفوفة من المستخدمين الذين حالتهم 'pending_approval'
 */
export const getPendingUsers = async (): Promise<User[]> => {
  try {
    // نفترض أن الـ backend يرجع البيانات داخل خاصية `data`
    const response = await apiClient.get<{ success: boolean; data: User[] }>('/users/status/pending_approval');
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch pending users:", error);
    // إرجاع مصفوفة فارغة في حالة حدوث خطأ لمنع تعطل التطبيق
    return [];
  }
};

/**
 * دالة للموافقة على مستخدم وتغيير حالته إلى 'active'
 * @param userId - معرف المستخدم للموافقة عليه
 * @returns معلومات المستخدم المحدثة
 */
export const approveUser = async (userId: number): Promise<User> => {
  // نفترض أن الـ backend يرجع المستخدم المحدث داخل خاصية `data`
  const response = await apiClient.patch<{ success: boolean; data: User }>(`/users/${userId}/approve`);
  return response.data.data;
};

/**
 * [ADMIN] جلب قائمة المستخدمين لدور معين للاختيار في النماذج
 * @param role - الدور المطلوب (lawyer, trainee, subscriber)
 */
export const getUsersByRoleForSelection = async (role: UserRole): Promise<UserSelectionData[]> => {
  // نفترض أن لديك نقطة نهاية جديدة لهذا الغرض
  const response = await apiClient.get<{ data: UserSelectionData[] }>(`/users/for-selection/${role}`);
  return response.data.data;
};
